// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__S1o67"};